// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 无权限访问
import erroPage from '@/views/erroPage';

import testPage from '@/views/testPage';
// 银联收银台
import paymentCounter  from '@/views/paymentCounter'

// 注册
import register from '@/views/register';
// 找回密码
import retrievePassword from '@/views/retrievePassword';

import initialPasswordSet from "@/views/initialPasswordSet";

// 用户协议
import userAgreement from '@/views/userAgreement';


// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */
// 商品管理
import Goods from '@/views/goods/Goods';
// 机器信息管理
import Machine from '@/views/machine/Machine';
// 货道信息管理
import MachineAisle from '@/views/machine/MachineAisle';
/**
 * 订单管理
 */
// 交易订单
import Order from '@/views/pay/Order';
/**
 * 系统管理
 */
// 用户管理
import user from '@/views/system/user';
// 菜单管理
import Module from '@/views/system/Module';
// 角色管理
import Role from '@/views/system/Role';
// 公司管理
import Dept from '@/views/system/Dept';
// 系统环境变量
import Variable from '@/views/system/Variable';
// 权限管理
import Permission from '@/views/system/Permission';
/**
 * 支付管理
 */
// 支付配置信息
import MachineConfig from '@/views/machine/MachineConfig';
// 支付配置
import Config from '@/views/pay/Config';
/**
 * 数据监控
 */
// 监控查询
import druidLogin from '@/views/druid/login';

// 图表界面
import statistics from '@/views/charts/statistics';

// 限时折扣
import limitDiscounts from '@/views/limitDiscounts/index'
// 秒杀
import spike  from '@/views/spike/index'

// 红包页面
import redenvelopes from '@/views/redenvelopes/index'
// 品牌
import brand from '@/views/brand/index'
// 商品列表
import goodsList from '@/views/goodsList/index'
// 商品详情
import goodsDetail from '@/views/goodsList/goodsDetail'
// 商家入驻 系列
import welcomesystem from '@/views/merchantSettled/welcomesystem'
import merchantTypeSelect from '@/views/merchantSettled/merchantTypeSelect'
import merchantApply from '@/views/merchantSettled/merchantApply'
import merchantForm from '@/views/merchantSettled/merchantForm'
import merchantStatus from '@/views/merchantSettled/merchantStatus'
import merchantpayFor from '@/views/merchantSettled/menchantpayFor'
import storeOpen from '@/views/merchantSettled/storeOpen'

// 购物车
import shoppingcart from '@/views/shoppingcart/shoppingcart'
import orderDetail from '@/views/shoppingcart/orderDetail'
import orderNow from '@/views/shoppingcart/orderNow'
import wxERweima from '@/views/shoppingcart/wxERweima'

// 头部客户服务的 相关文章分类
import serviceArticle from '@/views/serviceArticle/index'
import siteHelp from '@/views/serviceArticle/siteHelp' // 站点帮助
import siteHelpDetail from '@/views/serviceArticle/siteHelpDetail' // 站点帮助详情


// 我的订单
import myOrder from '@/views/myOrder/index'
import myOrderRight from '@/views/myOrder/myOrder'
import goodsAppraisal from '@/views/myOrder/goodsAppraisal'
import orderAppraisal from '@/views/myOrder/evaluationePage/orderAppraisal'
import gotoEvaluation from '@/views/myOrder/evaluationePage/gotoEvaluation'
import evaluationDetail from '@/views/myOrder/evaluationePage/evaluationDetail'
import pointsOrder from '@/views/myOrder/pointsOrder'
import myOrderDetail from '@/views/myOrder/myOrderDetail'
import myOrderDetailCMB from '@/views/myOrder/myOrderDetailCMB'
import myRefund  from '@/views/myOrder/myRefund'

// 关注中心
import goodsCollection from '@/views/myOrder/attentionCenter/goodsCollection' // 商品收藏
import myFooter from '@/views/myOrder/attentionCenter/myFooter' // 我的足迹
import shopCollection from '@/views/myOrder/attentionCenter/shopCollection' // 店铺收藏
// 支付成功
import paySuccess  from '@/views/paySuccess'

// 个人中心
import myInfomation from '@/views/myOrder/myCenter/myInfo' // 个人信息
// import myInfo from '@/views/myOrder/myCenter/myInfo' // 账号安全
// import myInfo from '@/views/myOrder/myCenter/myInfo' // 绑定授权
import address from '@/views/myOrder/myCenter/address'  // 收货地址
import contacts from '@/views/myOrder/myCenter/contacts'  // 联系人

// 客户服务
import refund from '@/views/myOrder/customerService/refund' // 退款退货
import refundDetail from '@/views/myOrder/refundDetail' // 退款退货
import consultation from '@/views/myOrder/customerService/consultation' // 商品咨询

// 财产中心
import myRedPack from '@/views/myOrder/propertyCenter/myRedPack'  // 我的红包
import myScores from '@/views/myOrder/propertyCenter/myScores' // 我的积分

// 首页main
import main from '@/views/dashboard/main';
// 首页-店铺街
import store from '@/views/store/store';
import messageBox from '@/views/messageBox';

// 经销商
import dealerSettled from '@/views/dealerSettled/dealerSettled'

// import shopStore from '@/views/store/shopStore';
import shopStore from '@/views/store/storeHome';


/** 供应商 **/
// 首页
import supplier from '@/views_supplier/index';
// 首页main
import main_supplier from '@/views_supplier/dashboard/main';
// 首页-店铺街
import store_supplier from '@/views_supplier/store/store';
// import shopStore_supplier from '@/views_supplier/store/shopStore';
import shopStore_supplier from '@/views_supplier/store/storeHome';
// 商品列表
import goodsList_supplie from '@/views_supplier/goodsList/index'
// 联系我们
// import contactUs from '@/views_supplier/contactUs/contactUs';
// 商品详情
import goodsDetail_supplie from '@/views_supplier/goodsList/goodsDetail'
// 购物车
import shoppingcart_supplie from '@/views_supplier/shoppingcart/shoppingcart'
// 下单
import orderDetail_supplie from '@/views_supplier/shoppingcart/orderDetail'

/** 供应商 **/
// 我的订单
import myOrder_supplier from '@/views_supplier/myOrder/index'
import myOrderRight_supplier from '@/views_supplier/myOrder/myOrder'
// import goodsAppraisal_supplier from '@/views_supplier/myOrder/goodsAppraisal'
import myOrderDetail_supplier from '@/views_supplier/myOrder/myOrderDetail'
import myRefund_supplier  from '@/views_supplier/myOrder/myRefund'
// 个人中心
// import address_supplier from '@/views_supplier/myOrder/myCenter/address'  // 收货地址
// 财产中心
// import myRedPack_supplier from '@/views_supplier/myOrder/propertyCenter/myRedPack'  // 我的红包



/** 积分商城 **/
import pointMall from '@/views/pointMall/pointMall'
// 积分商城 积分商品详情
import pointsProDetails from '@/views/pointMall/pointsProDetails'

/** 站点导航 **/
import siteNavigation from '@/views/siteNavigation/siteNavigation'
import userCenter from '@/views/siteNavigation/userCenter'
import paymentCenter from '@/views/siteNavigation/paymentCenter'

/** 拍卖 **/
import auctionIndex from '@/views/auction/index'
import myAuction from '@/views/auction/myAuction'
import auctionDetail from '@/views/auction/auctionDetail'
import auctionOrder from '@/views/auction/auctionOrder'
import auctionOrderDetail from '@/views/auction/auctionOrderDetail'
import createAuctionOrder from '@/views/auction/createAuctionOrder'
import auctionBxm from '@/views/auction/auctionBxm'


// 启用路由
Vue.use(Router);

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 导出路由
export default new Router({
  // mode: 'history',  //去掉url中的#
  scrollBehavior(to,from,savePosition){
    if(savePosition){
      return savePosition
    }else{
      return {x:0,y:0}
    }
  },
  routes: [
    {
      path: '/',
      name: '首页',
      component: index,
      iconCls: 'el-icon-tickets',
      redirect: '/',
      hidden: true,
      meta: {
        requireAuth: false
      },
      children: [
        {
          path: '/',
          name: '嵌套在首页',
          component: main,
          meta: {
            requireAuth: false
          }
        }, {
          path: '/store',
          name: '店铺街',
          component: store,
          meta: {
            requireAuth: false
          }
        },
        {
          path: '/shopStore',
          name: '店铺详情',
          component: shopStore,
          meta: {
            requireAuth: false
          }
        },
        {
          path: '/shoppingcart',
          name: '购物车',
          component: shoppingcart,
          hidden: true,
          meta: {
            requireAuth: true
          }
        },{
          path: '/orderDetail',
          name: '购物车订单',
          component: orderDetail,
          hidden: true,
          meta: {
            requireAuth: true
          }
        },{
          path: '/orderNow',
          name: '购物车付款',
          component: orderNow,
          hidden: true,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/paySuccess',
          name: '支付成功',
          component: paySuccess,
          hidden: true,
          meta: {
            requireAuth: true
          }
        },

        {
          path: '/redenvelope',
          name: '红包',
          component: redenvelopes,
          hidden: true,
          meta: {
            requireAuth: false
          }
        },{
          path: '/brand',
          name: '品牌',
          component: brand,
          hidden: true,
          meta: {
            requireAuth: false
          }
        }, {
          path: '/goodsList',
          name: '商品列表',
          component: goodsList,
          hidden: true,
          meta: {
            requireAuth: false
          }
        }, {
          path: '/goodsDetail',
          name: '商品详情',
          component: goodsDetail,
          hidden: true,
          meta: {
            requireAuth: false
          }
        },
        {
          path: '/pointMall',
          name: '积分商城',
          component: pointMall,
          hidden: true,
          meta: {
            requireAuth: false
          }
        },
        // pointsProDetails
        {
          path: '/pointsProDetails',
          name: '积分商城详情',
          component: pointsProDetails,
          hidden: true,
          meta: {
            requireAuth: false
          }
        },
        {
          path: '/limitDiscounts',
          name: '限时折扣',
          component: limitDiscounts,
          hidden: true,
          meta: {
            requireAuth: false
          }
        },
        {
          path: '/spike',
          name: '秒杀',
          component: spike,
          hidden: true,
          meta: {
            requireAuth: false
          }
        },
        {
          path: '/gotoEvaluation',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: '去评价',
          component: gotoEvaluation
        },
        {
          path: '/orderAppraisal',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: '订单评价',
          component: orderAppraisal //orderAppraisal
        },
        {
          path: '/evaluationDetail',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: '商品评价详情',
          component: evaluationDetail
        },
        {
          path: '/dealerSettled',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: '申请经销商',
          component: dealerSettled
        },
        {
          path: '/dealerStatus',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: '申请经销商状态',
          component:  () => import('@/views/dealerSettled/dealerStatus')
        },
        {
          path: '/dealer',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: '经销商专区',
          component:  () => import('@/views/dealer/index')
        },
        {
          path: '/serviceArticle',
          name: '文章分类',
          redirect: '/siteHelp',
          component: serviceArticle,
          hidden: true,
          meta: {
            requireAuth: true
          },
          children: [
            {
              path: '/siteHelp',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '站点帮助',
              component: siteHelp,
              meta: {
                requireAuth: true
              },

            },
            {
              path: '/siteHelpDetail',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '站点帮助详情',
              component: siteHelpDetail,
              meta: {
                requireAuth: true
              },

            },
          ]
        },
        {
          path: '/myOrder',
          name: '我的订单管理',
          redirect: '/myOrderRight',
          component: myOrder,
          hidden: true,
          meta: {
            requireAuth: true
          },
          children: [
            {
              path: '/myOrderRight',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '我的订单',
              component: myOrderRight,
              meta: {
                requireAuth: true
              },

            },
            {
              path: '/myOrderDetail',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '订单详情',
              component: myOrderDetail
            },
            {
              path: '/myOrderDetailCMB',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '订单详情',
              component: myOrderDetailCMB,
              hidden: true
            },
            {
              path: '/myRefund',//退款页面 付完钱可以申请退款页面
              name: '退款编写',
              component: myRefund
            },
            {
              path: '/refundDetail',//退款页面 付完钱可以申请退款页面
              name: '退款详情',
              component: refundDetail
            },
            {
              path: '/goodsAppraisal',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '商品评价',
              component: goodsAppraisal
            },
            {
              path: '/pointsOrder',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '积分订单',
              component: pointsOrder
            },
            {
              path: '/goodsCollection',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '商品收藏',
              component: goodsCollection,
              meta: {
                requireAuth: true
              },
            },

            {
              path: '/shopCollection',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '店铺收藏',
              component: shopCollection
            },
            {
              path: '/myFooter',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '我的足迹',
              component: myFooter,
              meta: {
                requireAuth: true
              },
            },
            {
              path: '/myInfomation',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '个人信息',
              component: myInfomation,
              meta: {
                requireAuth: true
              },
            },
            {
              path: '/address',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '收货地址',
              component: address
            },
            {
              path: '/contacts',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '联系人',
              component: contacts
            },
            {
              path: '/refund',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '退款退货',
              component: refund
            },
            {
              path: '/consultation',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '商品咨询',
              component: consultation
            },
            {
              path: '/myScores',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '我的积分',
              component: myScores
            },
            {
              path: '/myRedPack',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
              name: '我的红包',
              component: myRedPack
            }
          ]
        },
      ]
    },
    {
      path: '/welcomesystem',
      name: '商家入驻欢迎',
      component: welcomesystem,
      hidden: true,
      meta: {
        requireAuth: true
      }
    },  {
      path: '/merchantTypeSelect',
      name: '商家入驻选择',
      component: merchantTypeSelect,
      hidden: true,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/merchantApply',
      name: '商家入驻协议',
      component: merchantApply,
      hidden: true,
      meta: {
        requireAuth: true
      }
    },{
      path: '/merchantForm',
      name: '商家入驻表单',
      component: merchantForm,
      hidden: true,
      meta: {
        requireAuth: true
      }
    },{
      path: '/merchantStatus',
      name: '商家入驻平台审核',
      component: merchantStatus,
      hidden: true,
      meta: {
        requireAuth: true
      }
    },{
      path: '/merchantpayFor',
      name: '商家入驻平台交费',
      component: merchantpayFor,
      hidden: true,
      meta: {
        requireAuth: true
      }
    },{
      path: '/storeOpen',
      name: '商家入驻店铺开通',
      component: storeOpen,
      hidden: true,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/testPage',
      name: '测试页面',
      component: testPage,
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/paymentCounter',
      name: '收银台',
      component: paymentCounter,
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/login',
      name: '登录',
      component: login,
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/erroPage', // 无权访问页面
      name: '404',
      component: erroPage,
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/messageBox',
      name: '消息盒子',
      component: messageBox,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/register',
      name: '注册',
      component: register,
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/retrievePassword',
      name: '找回密码',
      component: retrievePassword,
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/initialPasswordSet',
      name: '修改登录初始密码',
      component: initialPasswordSet,
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/userAgreement',
      name: '用户协议',
      component: userAgreement,
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/wxERweima',
      name: '微信支付二维码',
      component: wxERweima,
      hidden: true,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/generalCode',
      name: '通用支付二维码',
      component:  () => import('@/views/shoppingcart/generalCode'),
      hidden: true,
      meta: {
        requireAuth: true
      }
    },

    /** 站点导航 */
    {
      path: '/siteNavigation',
      name: '站点导航首页',
      component: siteNavigation,
      iconCls: 'el-icon-tickets',
      redirect: '/userCenter',
      hidden: true,
      meta: {
        requireAuth: true
      },
      children: [
        {
          path: '/userCenter',
          name: '用户中心',
          component: userCenter,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/paymentCenter',
          name: '支付中心',
          component: paymentCenter,
          meta: {
            requireAuth: true
          }
        },


      ]
    },
    /**拍卖*/
    {
      path: '/auctionIndex',
      name: '拍卖活动',
      redirect: '/myAuction',
      component: auctionIndex,
      hidden: true,
      meta: {
        requireAuth: true
      },
      children: [
        {
          path: '/myAuction',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: '个性化拍卖',
          component: myAuction,
          meta: {
            requireAuth: true
          },

        },
        {
          path: '/auctionDetail',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: '拍卖详情',
          component: auctionDetail,
          meta: {
            requireAuth: true
          },
        },
        {
          path: '/auctionOrder',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: '拍卖订单',
          component: auctionOrder,
          meta: {
            requireAuth: true
          },
        },
        {
          path: '/auctionOrderDetail',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: '拍卖订单详情',
          component: auctionOrderDetail,
          meta: {
            requireAuth: true
          },
        },
        {
          path: '/auctionBxm',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: '收货地址',
          component: auctionBxm,
          meta: {
            requireAuth: true
          },
        },
      ]
    },
    {
      path: '/createAuctionOrder',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
      name: '去下单',
      component: createAuctionOrder,
      meta: {
        requireAuth: true
      },
    },

// 以下 批发市场 供应商 首页
    {
      path: '/supplier',
      name: '供应商首页',
      component: supplier,
      iconCls: 'el-icon-tickets',
      redirect: '/supplierIndex',
      hidden: true,
      meta: {
        requireAuth: false
      },
      children: [
        {
          path: '/supplierIndex',
          name: '供应商嵌套在首页',
          component: main_supplier,
          meta: {
            requireAuth: false
          }
        }, {
          path: '/store_supplier',
          name: '店铺馆',
          component: store_supplier,
          meta: {
            requireAuth: false
          }
        },
        {
          path: '/shopStore_supplier',
          name: '供应商店铺详情',
          component: shopStore_supplier,
          meta: {
            requireAuth: false
          }
        },
        {
          path: '/goodsList_supplier',
          name: '供应商商品列表',
          component: goodsList_supplie,
          hidden: true,
          meta: {
            requireAuth: false
          }
        },
        // {
        //     path: '/contactUs',
        //     name: '联系我们',
        //     component: contactUs,
        //     hidden: true,
        //     meta: {
        //         requireAuth: false
        //     }
        // },
        {
          path: '/goodsDetail_supplie',
          name: '供应商商品详情',
          component: goodsDetail_supplie,
          hidden: true,
          meta: {
            requireAuth: false
          }
        },

        // 与普通供应商的页面一样(公共页面)
        // {
        //     path: '/shoppingcart',
        //     name: '购物车',
        //     component: shoppingcart,
        //     hidden: true,
        //     meta: {
        //         requireAuth: true
        //     }
        // },
        // {
        //     path: '/orderDetail',
        //     name: '购物车订单',
        //     component: orderDetail,
        //     hidden: true,
        //     meta: {
        //         requireAuth: true
        //     }
        // },
        // {
        //     path: '/myOrder_supplier',
        //     name: '我的订单',
        //     redirect: '/myOrderRight__supplier',
        //     component: myOrder,
        //     hidden: true,
        //     meta: {
        //         requireAuth: true
        //     },
        //     children: [
        //         {
        //           path: '/myOrderRight__supplier',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        //           name: '我的订单',
        //           component: myOrderRight,
        //           meta: {
        //             requireAuth: true
        //         },
        //         },
        //         {
        //             path: '/myOrderDetail_supplier',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        //             name: '订单详情',
        //             component: myOrderDetail
        //         },
        //         {
        //             path: '/myRefund_supplier',//退款页面 付完钱可以申请退款页面
        //             name: '订单详情',
        //             component: myRefund
        //         },
        //         {
        //             path: '/goodsAppraisal_supplier',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        //             name: '商品评价',
        //             component: goodsAppraisal
        //         },
        //         {
        //           path: '/pointsOrder_supplier',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        //           name: '商品积分',
        //           component: pointsOrder
        //         },
        //         {
        //             path: '/goodsAppraisal_supplier',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        //             name: '商品评价',
        //             component: goodsAppraisal
        //         },
        //         {
        //           path: '/pointsOrder_supplier',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        //           name: '商品积分',
        //           component: pointsOrder
        //         },
        //         {
        //             path: '/address_supplier',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        //             name: '收货地址',
        //             component: address
        //         },
        //         {
        //           path: '/myRedPack_supplier',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        //           name: '我的红包',
        //           component: myRedPack
        //         }
        //       ]
        // },


      ]
    },
    // {
    //     path: '/supplier',
    //     name: '供应商首页',
    //     component: supplier,
    //     iconCls: 'el-icon-tickets',
    //     redirect: '/supplierIndex',
    //     hidden: true,
    //     meta: {
    //         requireAuth: false
    //     },
    //     children: [
    //          {
    //             path: '/supplierIndex',
    //             name: '供应商嵌套在首页',
    //             component: main_supplier,
    //             meta: {
    //                 requireAuth: false
    //             }
    //         }, {
    //             path: '/store_supplier',
    //             name: '店铺馆',
    //             component: store_supplier,
    //             meta: {
    //                 requireAuth: false
    //             }
    //         },
    //         {
    //             path: '/goodsList_supplier',
    //             name: '商品列表',
    //             component: goodsList_supplie,
    //             hidden: true,
    //             meta: {
    //                 requireAuth: false
    //             }
    //         },
    //         {
    //             path: '/contactUs',
    //             name: '联系我们',
    //             component: contactUs,
    //             hidden: true,
    //             meta: {
    //                 requireAuth: false
    //             }
    //         },
    //         {
    //             path: '/goodsDetail_supplie',
    //             name: '商品详情',
    //             component: goodsDetail_supplie,
    //             hidden: true,
    //             meta: {
    //                 requireAuth: false
    //             }
    //         },
    //         {
    //             path: '/shoppingcart_supplie',
    //             name: '购物车',
    //             component: shoppingcart_supplie,
    //             hidden: true,
    //             meta: {
    //                 requireAuth: true
    //             }
    //         },
    //         {
    //             path: '/orderDetail_supplie',
    //             name: '购物车订单',
    //             component: orderDetail_supplie,
    //             hidden: true,
    //             meta: {
    //                 requireAuth: true
    //             }
    //         },
    //         {
    //             path: '/myOrder_supplier',
    //             name: '我的订单',
    //             redirect: '/myOrderRight_supplier',
    //             component: myOrder_supplier,
    //             hidden: true,
    //             meta: {
    //                 requireAuth: true
    //             },
    //             children: [
    //                 {
    //                   path: '/myOrderRight_supplier',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
    //                   name: '我的订单',
    //                   component: myOrderRight_supplier,
    //                   meta: {
    //                     requireAuth: true
    //                 },
    //                 },
    //                 {
    //                     path: '/myOrderDetail_supplier',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
    //                     name: '订单详情',
    //                     component: myOrderDetail_supplier
    //                 },
    //                 {
    //                     path: '/myRefund_supplier',//退款页面 付完钱可以申请退款页面
    //                     name: '订单详情',
    //                     component: myRefund_supplier
    //                 },
    //                 {
    //                     path: '/goodsAppraisal_supplier',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
    //                     name: '商品评价',
    //                     component: goodsAppraisal_supplier
    //                 },
    //                 {
    //                   path: '/pointsOrder_supplier',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
    //                   name: '商品积分',
    //                   component: pointsOrder_supplier
    //                 },
    //                 {
    //                     path: '/goodsAppraisal_supplier',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
    //                     name: '商品评价',
    //                     component: goodsAppraisal_supplier
    //                 },
    //                 {
    //                   path: '/pointsOrder_supplier',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
    //                   name: '商品积分',
    //                   component: pointsOrder_supplier
    //                 },
    //                 {
    //                     path: '/address_supplier',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
    //                     name: '收货地址',
    //                     component: address
    //                 },
    //                 {
    //                   path: '/myRedPack_supplier',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
    //                   name: '我的红包',
    //                   component: myRedPack
    //                 }
    //               ]
    //         },


    //     ]
    // },

  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js